import * as React from "react"
import { GatsbyImage } from "gatsby-plugin-image" 
import Footer from "../components/footer"
import Title from "../components/Title" 

class PageFooter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {hover:false};
    this.pageTransition = this.pageTransition.bind(this);
     
  }

  pageTransition(e){
    e.preventDefault();
    var link = document.querySelector('.footer-link').getAttribute('href');
    document.querySelector('.floating--cursor').classList.add('transition-out');
    document.querySelector('.bottom-menu--fixed').classList.add('is-transitioning');  
    document.querySelector('.loader-icon').classList.add('is-rotating');  
    setTimeout(function(){ 
      document.querySelector('.preloader').classList.add('fade-in'); 
    }, 1000);
    setTimeout(function(){ 
      window.location.href = link; 
    }, 1500); 
  }

  mouseOver(e) {
    document.querySelector('.image-hover--scale').classList.add('scaling');
    var images = document.querySelectorAll('.image-will--darken');
    for (var i = 0; i < images.length; i++) { 
      images[i].classList.add('darkening');
    } 
  } 
  mouseLeave() {
    document.querySelector('.image-hover--scale').classList.remove('scaling');
    var images = document.querySelectorAll('.image-will--darken');
    for (var i = 0; i < images.length; i++) { 
      images[i].classList.remove('darkening');
    } 
  }
  mouseClick() {
    document.querySelector('.image-hover--scale').classList.add('scaled');  
    var images = document.querySelectorAll('.image-will--darken');
    for (var i = 0; i < images.length; i++) { 
      images[i].classList.add('darkened');
    } 
  }
  render() { 
    return (
      <div className="page--footer pos-rel h-200 m-150 overflow-hidden mtn1 flex flex-wrap"> 
        <div className="w-100 z-2 h-100 align-center justify-center flex"> 
          <a className="footer-link" href={this.props.link} onClick={this.pageTransition.bind(this)}>
            <div className="inner text-center mt30">
              <p className="strong fade-in" data-scroll>Next Page</p>
              <div  role="presentation" onMouseOver={this.mouseOver} onClick={this.mouseClick} onFocus={this.mouseOver} onMouseOut={this.mouseLeave} onBlur={this.mouseLeave} >
                <Title Line1={this.props.title} scroll="true" heading="h0"/>
              </div>
            </div>
          </a>
        </div>
        <div className="w-100 mta z-2">
          <Footer />
        </div>
        <div className="bg-image--container image-will--scale">
          <div className="bg-image--container image-hover--scale">
            <GatsbyImage image={this.props.image} alt={this.props.title} className="bg-image" />
          </div>
        </div> 
      </div>
    )
  }
} 

export default PageFooter

